import type { FormikErrors, FormikTouched } from "formik";

type FieldStateHelperParams<FormType> = {
    errors: FormikErrors<FormType>;
    touched: FormikTouched<FormType>;
};

export const fieldStateHelper = <FormType>({
    errors,
    touched,
}: FieldStateHelperParams<FormType>) => {
    const isFieldInvalid = (fieldName: string) => {
        return Boolean(errors?.[fieldName] && touched?.[fieldName]);
    };

    const getFieldError = (fieldName: string) => {
        return errors?.[fieldName] as string | undefined;
    };

    const isFieldSuccess = (fieldName: string) => {
        return Boolean(!errors?.[fieldName] && touched?.[fieldName]);
    };

    const getFieldStateProps = (fieldName: string) => {
        return {
            isInvalid: isFieldInvalid(fieldName),
            isSuccess: isFieldSuccess(fieldName),
            error: getFieldError(fieldName),
        };
    };

    const getIconProps = (fieldName: string) => {
        const isSuccess = isFieldSuccess(fieldName);
        if (isSuccess) {
            return {
                rightIcon: "ok",
            };
        }
        return {};
    };

    return {
        isFieldInvalid,
        getFieldError,
        isFieldSuccess,
        getFieldStateProps,
        getIconProps,
    };
};
